// Mock data for CLOUD IT website

export const services = [
  {
    id: 1,
    title: "Website Development",
    description: "Enterprise-grade responsive websites built with cutting-edge technologies. Scalable, secure, and optimized for performance.",
    icon: "Globe"
  },
  {
    id: 2,
    title: "App Development",
    description: "Custom mobile & web applications tailored to your business needs. Native and cross-platform solutions.",
    icon: "Smartphone"
  },
  {
    id: 3,
    title: "Design & Branding",
    description: "Modern UI/UX and brand identity systems that captivate and convert. Data-driven design strategies.",
    icon: "Palette"
  },
  {
    id: 4,
    title: "Agentic AI Solutions",
    description: "Autonomous AI systems, workflow automation, and intelligent agents that transform business operations.",
    icon: "Brain"
  },
  {
    id: 5,
    title: "Business Tools",
    description: "CRM systems, automation tools, and cloud platforms designed for modern enterprises.",
    icon: "Wrench"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Cutting-edge AI Integration",
    description: "Leveraging the latest AI technologies to deliver intelligent solutions",
    icon: "Zap"
  },
  {
    id: 2,
    title: "Scalable Cloud Architecture",
    description: "Built for growth with robust, scalable infrastructure",
    icon: "Cloud"
  },
  {
    id: 3,
    title: "Secure & Compliant Systems",
    description: "Enterprise-grade security and regulatory compliance",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Dedicated Expert Team",
    description: "Experienced professionals committed to your success",
    icon: "Users"
  },
  {
    id: 5,
    title: "Long-term Partnership",
    description: "We're invested in your continued growth and success",
    icon: "Handshake"
  }
];

export const stats = [
  {
    id: 1,
    value: 200,
    label: "Projects Delivered",
    suffix: "+"
  },
  {
    id: 2,
    value: 100,
    label: "Business Clients",
    suffix: "+"
  },
  {
    id: 3,
    value: 99,
    label: "Client Satisfaction",
    suffix: "%"
  },
  {
    id: 4,
    value: 24,
    label: "Support Available",
    suffix: "/7"
  }
];

export const contactInfo = {
  phone: "888-383-3213",
  email: "support@clouditllc.ai",
  address: "721 Terrace Blvd, Depew NY 14043"
};
